import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
    imprestApplications,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { LeaveApplicationsColumns, imprestApplicationsColumns, staffClaimApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import LeaveApplicationForm from "./form";
import StaffClaimDocumentsDrawer from "./StaffClaimDocumentsDrawer";

const base_url = HRService.uri;
function ClaimPendingApprovalsTable() {
  const [docsDrawerOpen, setDocsDrawerOpen] = useState(false);
  const [selectedRecordForDocs, setSelectedRecordForDocs] = useState(null);

const actions = {
 // entity: " Imprest Approvals",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

 // ---------- APPROVE ----------
   APPROVECLAIM: {
      key: "APPROVECLAIM",
      button_name: "Approve",
      Show_Button: (row) => row.statusId === 1,   // only when pending
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },

  // ---------- REJECT ----------
  // ---------- REJECT ----------
    REJECTCLAIM: {
      key: "REJECTCLAIM",
      button_name: "Reject",
      Show_Button: (row) => row.statusId === 1,   // only when pending
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewClaimLines: {
      key: "ViewClaimLines",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewDocuments: {
      key: "ViewDocuments",
      button_name: "View Documents",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row) => {
        setSelectedRecordForDocs(row);
        setDocsDrawerOpen(true);
      },
    },
   modelName: "allStaffClaimPendingApproval", 
         dataObject: {
             // *** UPDATE: The input field must match the GraphQL variable (feeNotesLines) ***
             inputFields: {
                approverUserId: null,
            },
             
             // *** UPDATE: inputObjectName matches the GraphQL operation name (without 'query') ***
             inputObjectName: "allStaffClaimPendingApproval", 
             
             // *** UPDATE: inputSubObjectName is the array of results returned by the operation ***
             // Assuming the results array is directly returned by the operation.
             // If the API nests the array under another field, change this accordingly.
             inputSubObjectName: "parameters", // Often the same as inputObjectName if the array is directly returned.
             
            returnFields: [
        "id",
        "title",
        "description",
        "totalAmount",            // DB column = TotalAmount
        "status",
        "statusText",
        "approverCount",
        "declinerCount",
        "declinedReason",
        "caseRelated",
        "caseId",
        "caseTitle",
        "isDisbursed",
        "isActive",
        "createdDate",
        "updatedDate",
        "approvedDate",
        "disbursedDate",
        "currencyId",
        "currencyCode",
        "currencyName",
        "snapshotExchangeRate",
        "currentExchangeRate",
        "amountInBaseCurrency",
        "accountId",
        "accountName",
        "disbursementAccountType",
        "disbursementBankAccountId",
        "disbursementBankAccountName",
        "paymentReference",
        "companyId",
        "company",
        "employeeId",
        "userId",
        "applicantUsername",
        "applicantFullName",
        "regionId",
        "region",
        "branchId",
        "branch",
        "createdByUsername",
        "updatedByUsername",
        "approvedByUsername",
        "disbursedByUsername",
        "approverComments"
        ]
         },
  showStatus: true,
};

  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Staff Claim Approvals"
          subtitle="View all Staff Claim Pending Approval approvals"
          columns={staffClaimApplicationsColumns}
          FormComponent={LeaveApplicationForm}
          actions={actions}
          base_url={base_url}
        />
        <StaffClaimDocumentsDrawer
          open={docsDrawerOpen}
          onClose={() => {
            setDocsDrawerOpen(false);
            setSelectedRecordForDocs(null);
          }}
          claimId={selectedRecordForDocs?.id}
        />
      </>
    </Box>
  );
}

export default ClaimPendingApprovalsTable;
